import * as L from 'leaflet';

import { getPopupSchool } from '../lib';
import { schoolIcon, zoomThreshold } from '../options';
import { searchProps } from '../lib';

export function initSchoolLayer(map, state) {
    return L.geoJSON(null, {
        filter: (feature) => {
            if (!state.filterActive) return true;

            const isProjectChecked = state.projects.some(
                (r) => feature.properties.projects.indexOf(r) >= 0
            );

            const isTagChecked = state.tags.every(
                (r) => feature.properties.tags.indexOf(r) >= 0
            );

            if (state.searchTerm !== '') {
                const matchesSearchTerm = searchProps(
                    feature,
                    state.searchTerm
                );

                return matchesSearchTerm;
            }

            if (state.isSet.tags) return isTagChecked;

            return isProjectChecked && isTagChecked;
        },
        pointToLayer: function (feature, latlng) {
            let school = L.divIcon(schoolIcon);
            return L.marker(latlng, { icon: school });
        },
        onEachFeature: function (feature, layer) {
            const customProjects = feature.properties.projects.join(', ');
            const customTags = feature.properties.tags.join(', ');

            const customPopup = getPopupSchool(
                feature.properties.name,
                feature.properties.type,
                feature.properties.location,
                feature.properties.description,
                customProjects,
                customTags,
                feature.properties.url,
                feature.properties.mail
            );
            layer.bindPopup(customPopup, { className: 'lmz-popup' });

            const customTooltip = feature.properties.name;
            /* eslint-disable indent */
            map.getZoom() >= zoomThreshold
                ? layer.bindTooltip(customTooltip, {
                      permanent: true,
                      opacity: 0.9,
                  })
                : layer.bindTooltip(customTooltip, {
                      permanent: false,
                      opacity: 0,
                  });
            /* eslint-enable indent */
        },
    });
}
